import React from 'react';
import { cn } from '../../lib/utils';

interface StatusBadgeProps {
  status: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  className = "",
  size = 'md'
}) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
      case 'approved':
      case 'completed':
      case 'registration_open':
      case 'attended':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'pending':
      case 'forming':
      case 'upcoming':
      case 'registered':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'rejected':
      case 'cancelled':
      case 'inactive':
      case 'withdrawn':
      case 'disqualified':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'in_progress':
      case 'submitted':
      case 'confirmed':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };

  return (
    <span className={cn(
      "inline-flex items-center rounded-full border font-medium",
      getStatusColor(status),
      sizeClasses[size],
      className
    )}>
      {status.replace('_', ' ').toUpperCase()}
    </span>
  );
}; 